import { Routes, Route, Navigate } from 'react-router-dom';
import { getPolySession } from '@poly/sdk-browser/react';

// Layout
import Layout from './components/Layout';

// Pages
import Dashboard from './pages/Dashboard';
import Devices from './pages/Devices';
import Platforms from './pages/Platforms';
import Messages from './pages/Messages';
import Governance from './pages/Governance';
import Settings from './pages/Settings';
import Login from './pages/Login';

export default function App() {
  const storedSession = getPolySession();
  const isLoggedIn = storedSession !== null;

  // Protected route wrapper
  function ProtectedRoute({ children }: { children: React.ReactNode }) {
    if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }
    return <>{children}</>;
  }

  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<Login />} />
      
      {/* Protected routes */}
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="devices" element={<Devices />} />
        <Route path="platforms" element={<Platforms />} />
        <Route path="messages" element={<Messages />} />
        <Route path="governance" element={<Governance />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      
      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
